<h4>{{MessageTitle}}</h4>
<div class="qrlabel">
    <div class="qrcode">
        <ng-content select=".qrcode-value"></ng-content>
    </div>
</div>
